export default {
    config: {
        defaultWidth: 60
    },
    default: {
        label: 'Age (off.)'
    },
    unique: [],
    sort: 'age.official',
    lang: {
        name: 'Official Age',
        category: 'Game',
        description: 'Publisher minimum age recommendation.',
        views: ['list', 'sheet'],
    },
    filters: ['age.official']
}
